import React from 'react';

const TimelinemMerchantFulfill = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.3"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <title>Timeline Fulfill</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-577.000000, -1695.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Timeline-Fulfill" transform="translate(0.000000, 792.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="file-alt-light" transform="translate(14.000000, 19.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M8.415625,7.05625 C8.29375,6.934375 8.096875,6.934375 7.975,7.053125 L5.225,9.78125 L4.034375,8.578125 C3.9125,8.45625 3.715625,8.45625 3.59375,8.575 L2.85625,9.30625 C2.734375,9.428125 2.734375,9.625 2.853125,9.746875 L4.99375,11.90625 C5.115625,12.028125 5.3125,12.028125 5.434375,11.909375 L9.140625,8.234375 C9.2625,8.1125 9.2625,7.915625 9.14375,7.79375 L8.415625,7.05625 Z M10.5,2 L8,2 C8,0.896875 7.103125,0 6,0 C4.896875,0 4,0.896875 4,2 L1.5,2 C0.671875,2 0,2.671875 0,3.5 L0,14.5 C0,15.328125 0.671875,16 1.5,16 L10.5,16 C11.328125,16 12,15.328125 12,14.5 L12,3.5 C12,2.671875 11.328125,2 10.5,2 Z M6,1.5 C6.275,1.5 6.5,1.725 6.5,2 C6.5,2.275 6.275,2.5 6,2.5 C5.725,2.5 5.5,2.275 5.5,2 C5.5,1.725 5.725,1.5 6,1.5 Z M10.5,14.25 C10.5,14.3875 10.3875,14.5 10.25,14.5 L1.75,14.5 C1.6125,14.5 1.5,14.3875 1.5,14.25 L1.5,3.75 C1.5,3.6125 1.6125,3.5 1.75,3.5 L3,3.5 L3,4.5 C3,4.775 3.225,5 3.5,5 L8.5,5 C8.775,5 9,4.775 9,4.5 L9,3.5 L10.25,3.5 C10.3875,3.5 10.5,3.6125 10.5,3.75 L10.5,14.25 Z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelinemMerchantFulfill;

